// import React from 'react'
// import { BrowserRouter, Routes, Route } from 'react-router-dom'
// import Home from './components/Home/Home'
// import Privacy from './components/Privacy/Privacy'
// import Terms from './components/Terms/Terms'
// import Contact from './components/Contact/Contact'
// import About from './components/About/About'


// const App = () => {
//   return (
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<Home/>} />
//           <Route path="/privacy&policy" element={<Privacy/>}/>
//           <Route path="/terms&conditions" element={<Terms/>}/>
//           <Route path="/contact" element={<Contact/>}/>
//           <Route path='/about' element={<About/>}/>
//         </Routes>
//       </BrowserRouter>
  
//   )
// }

// export default App



import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './components/Home/Home'
import Privacy from './components/Privacy/Privacy'
import Terms from './components/Terms/Terms'
import Contact from './components/Contact/Contact'
import About from './components/About/About'
import loadlogo from "../src/assets/main-logo.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

const App = () => {
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: false,     // whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    // Show loader after page is rendered
    setShowLoader(true)
    const timer = setTimeout(() => setShowLoader(false), 2000) // 2 seconds
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/privacy&policy" element={<Privacy/>}/>
          <Route path="/terms&conditions" element={<Terms/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path='/about' element={<About/>}/>
        </Routes>
      </BrowserRouter>
      {showLoader && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
        }}>
          <img src={loadlogo} alt="Loading..." style={{ width:"50%"}} data-aos="zoom-in"/>
        </div>
      )}
    </>
  )
}

export default App